// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"11238f6b","40":"6fd026a7","123":"40125d43"}[chunkId] + ".chunk.js";
};